import { Container, Modal,Box, Button,
     Input, Typography, TextField, Stack, 
     TabPanel,TabList,
     Tab,
     Tabs,
     Tooltip,Pagination
    } from '@mui/material'
import React, { useState ,useContext} from 'react'
import { Link, useParams } from 'react-router-dom';
import { DataGrid } from '@mui/x-data-grid';
import { AppContext } from "../context/AppProvider";
import { QRCodeContext } from "../context/QRCodeProvider";

import CloseButton from '../components/CloseButton'
import RefreshIcon from '@mui/icons-material/Refresh';
import * as API from '../utils/APICalls'
import * as helpers from '../utils/helpers'
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import BadgeIcon from '@mui/icons-material/Badge';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import QrCode from '@mui/icons-material/QrCode';


const ProductDataGrid = ({items}) => {
    // const {items, handleitemselect} = props 
    const { appData, updateAppData, setCurrentOrder,
        setCurrentProduct, 
        subView, setSubView,
        currentProduct } = useContext(AppContext)
        const { qrCodeData, updateQRCodeData } = useContext(QRCodeContext);
    const  handleitemselect = async (order) =>{
        try{
          console.log('[itemselect]:---order---',order)
    
          setCurrentOrder(order)
          // if(order?.qr_id){
    
            const res = await API.fetchQRByID(order?._qr_id)
              if(res?.data){
                updateQRCodeData(res?.data)
              }else{
                console.log('[Order click]:---NO QR Available---')
      
              }
            // console.log('[Order click]:', order)
            updateAppData({
              modalView:'review-order'
            })
          // }
        }catch(err){console.log(err)}
      }
    const shareColumns = [
        // { field: '_id', headerName: 'id', minWidth: 2 },
        { field: 'images', headerName: 'Pic', minWidth: 80,
            maxWidth:100, height:100,
            renderCell: (params) => {
       
        return ( 
        <img src ={params?.row.images[0]} width='auto' height='80px'/>

        )
    }
    },
      {
        field: 'name',
        headerName: 'Name',
        minWidth: 150,maxWidth:200

        // editable: true,
    //     renderCell: (params) => {
    // const date = new Date(params.value)
    // let formatted_date = date.toLocaleDateString('en-US', {
    //         month: '2-digit',
    //         day: '2-digit',
    //         year: '2-digit'
    //         })
    //     return formatted_date
          
        // },
      },
      {
        field: 'total_sales',
        headerName: 'Sales',
        minWidth: 60,
        maxWidth: 70,
        // valueGetter: (params) => {
    //     renderCell: (params) => {
    //     const type = params?.row?.type;
    //     const qr_id = params?.row?.qr_id;
    //     const asset_url = params?.row?.asset_url;
    //     const printFile = params?.row?.printFile;
    //     return (  <span style={{display:'flex',flex:1,justifyContent:'space-evenly',margin:'auto'}}>
    //                 {type === 'music'&& <MusicNoteIcon sx={{width: '1rem'}}/>}
    //                 {qr_id !== 'n/a'&& <QrCode sx={{width: '1rem',color: !qr_id ? 'red':'black'}}/>}
    //                 {asset_url !== 'n/a' && <BadgeIcon sx={{width: '1rem',color: !asset_url ? 'red':'black'}}/>}
    //                 {(printFile !== 'n/a' && type !== 'music') && <DriveFileMoveIcon sx={{width: '1rem',color: !printFile ? 'red':'black'}}/>}
    //             </span>)
    // },
  },
     
      {
        field: 'isActive',
        headerName: 'Status',
        minWidth: 60,
        renderCell:(params) =>{
                return(
                   <Box sx={{display:'flex',position:'relative', top: '0.2rem', right:'0.2rem',fontSize:'0.75rem',gap:'0.25rem',alignItems:'center',}}>
                        <div style={{content:'',width:'0.75rem',height:'0.75rem', borderRadius:'50%',backgroundColor: params? '#00FF00':'#ffe485', boxShadow:'inset 0px 0px 5px 3px rgba(0,0,0,0.3)'}}>&nbsp;</div>
                        {params ? 'active':'inactive'}
                    </Box>
                )}
        // renderCell: (params) => {
        // //   if (params.value === 'comp') {
        //     return (
        //       <Button
        //         variant="contained"
        //         color="primary"
        //         size="small"
        //         // onClick={() => handleButtonClick(params.row)}
        //       >
        //         review
        //       </Button>
        //     );
        //   } 
    
        //   return (
        //     <div style={{ color: params.value !== 'resend' ? '#FF00FF' : '#00ff00', display:'flex',fontSize:'0.85rem',
        //             alignContent:'center',
        //             alignItems:'center',
        //             fontFamily:'LCD2', //className='blink'
        //             justifyContent:'center'
        //             }}>
        //       {params.value}  <img style={{ alignSelf:'center'}} className='coin-rotate'
        //                  src={'/assets/RexCoin.png'} width='20px' height='auto'/>
        //     </div>
        //   )
        //   return params.value;
        },
      {
        // field: 'isComplete',
        headerName: 'Edit',
        width: 80,
        // editable: true,
        renderCell: (params) => {
        //   if (params.value === 'resend') {
            return (
              <Button
                variant="contained"
                color="primary"
                size="small"
                onClick={()=>{
                    try{
                        setCurrentProduct(params.row)
                        updateAppData({
                            ...appData,
                            currentProduct,
                            modalView:'edit-product'
                        })
                    }catch(err){console.log(err)}
                    }}
        
              >
                Edit
              </Button>
            );
          } 
    
      },


      ];
    // console.log('items:', items) 
    return (
    <>
        <DataGrid
            rows={items}
            columns={shareColumns}
             getRowId={(row) => row._id}
            initialState={{
            pagination: {
                    paginationModel: {
                    pageSize: 15,
                    // color:'#00ff00'
                    },
                },
                }}
                components={{
                Pagination: (props) => (
                <Pagination {...props} className="custom-pagination" />
                ),}}
            // getRowClassName={() => 'share-row-text-color'}
            pageSizeOptions={[5]}
            checkboxSelection
            disableRowSelectionOnClick
          
            />
    </>
  )
}

export default ProductDataGrid